module.exports = __webpack_public_path__ + "img/19_58.ed3c402c.png";